import * as Sentry from '@sentry/vue';
import { onCLS, onINP, onLCP } from 'web-vitals';

const isObservabilityEnabled = (): boolean =>
  Boolean(import.meta.env.OBSERVABILITY_ENABLED && import.meta.env.SENTRY_DSN);

let isInitialized: boolean = false;

const observability = {
  init: (...args: Parameters<typeof Sentry.init>): void => {
    if (!isObservabilityEnabled() || isInitialized) {
      return;
    }

    Sentry.init(...args);
    isInitialized = true;
  },
  captureException: (...args: Parameters<typeof Sentry.captureException>): string => {
    if (!isInitialized) {
      return '';
    }

    return Sentry.captureException(...args);
  },
  captureMessage: (...args: Parameters<typeof Sentry.captureMessage>): string => {
    if (!isInitialized) {
      return '';
    }

    return Sentry.captureMessage(...args);
  },
  addBreadcrumb: (...args: Parameters<typeof Sentry.addBreadcrumb>): void => {
    if (!isInitialized) {
      return;
    }

    Sentry.addBreadcrumb(...args);
  },
};

const reportWebVitals = (): void => {
  if (!isInitialized) {
    return;
  }

  const report = (name: string, value: number, rating: string, delta: number): void => {
    observability.captureMessage(`web-vital:${name}`, {
      level: 'info',
      tags: {
        metric: 'web-vital',
        name,
        rating,
      },
      extra: {
        value,
        delta,
      },
    });
  };

  onCLS((metric) => report(metric.name, metric.value, metric.rating, metric.delta));
  onINP((metric) => report(metric.name, metric.value, metric.rating, metric.delta));
  onLCP((metric) => report(metric.name, metric.value, metric.rating, metric.delta));
};

export { isObservabilityEnabled, observability, reportWebVitals };
